<template>
  <div
    class="qa-dashboard-wrapper flex flex-col flex-1 h-full overflow-auto px-6"
  >
    <router-view />
  </div>
</template>

<style scoped>
.qa-dashboard-wrapper {
  background: #ffffff;
}

/* QA pages follow "white report" styling even in dark mode. */
::global(body.dark) .qa-dashboard-wrapper {
  background: #ffffff !important;
}
</style>
